import { graphql } from 'services/api';
import { GET_PAGES } from 'graphqlQueriesAndMutations/queries';
import { PageProps } from 'types/PageProps';
import { DynamicPageProps } from 'types/DynamicPageProps';

interface RespGetPagesProps {
	isSuccess: boolean;
	data: null | {
		data: PageProps[];
		limit: number;
		page: number;
		total: number;
		totalPages: number;
		__typename: string;
	};
}

export async function getPages(
	page: number,
	setTotalPage: React.Dispatch<React.SetStateAction<number>>,
	setPage: React.Dispatch<React.SetStateAction<number>>,
	setDynamicPagesList: React.Dispatch<React.SetStateAction<DynamicPageProps[]>>,
	handleNotify: any
) {
	const resp: RespGetPagesProps = { isSuccess: false, data: null };
	await graphql
		.query({
			query: GET_PAGES,
			variables: { limit: 10, page: page === 0 ? 1 : page },
			fetchPolicy: 'no-cache'
		})
		.then((res) => {
			resp.isSuccess = true;
			resp.data = res?.data?.pagesPaginated || null;
		})
		.catch((error) => {
			resp.isSuccess = false;
			resp.data = null;
			handleNotify(error?.message || 'Erro ao buscar as páginas.', 'error');
		});

	if (resp.isSuccess && resp.data) {
		setTotalPage(resp.data.totalPages);
		setPage(resp.data.page);
		if (resp.data.data) {
			setDynamicPagesList(resp.data.data);
		}
	}

	return resp;
}
